import { jsPDF } from "jspdf";

function writeParagraph(doc, text, x, y, maxWidth, lineHeight) {
  const lines = doc.splitTextToSize(String(text ?? ""), maxWidth);
  let cy = y;
  for (const ln of lines) {
    if (cy > 285) {
      doc.addPage();
      cy = 14;
    }
    doc.text(ln, x, cy);
    cy += lineHeight;
  }
  return cy;
}

function formatOpenList(products) {
  if (!Array.isArray(products) || products.length === 0) return "—";
  return products
    .map((p, i) => `${i + 1}. ${p.title || "?"} — ${p.openCount ?? 0} opens`)
    .join("\n");
}

function formatTopSelling(products) {
  if (!Array.isArray(products) || products.length === 0) return "—";
  return products
    .map((p, i) => `${i + 1}. ${p.title || "?"} — ${p.sold ?? 0} sold`)
    .join("\n");
}

/**
 * @param {object} snapshot — same shape as stored archive entry
 * @param {string} fileName
 */
export function downloadDashboardSnapshotPdf(snapshot, fileName) {
  const doc = new jsPDF();
  const margin = 14;
  const maxW = 182;
  const lh = 5;
  let y = 16;

  doc.setFontSize(15);
  y = writeParagraph(
    doc,
    snapshot.title || "Dashboard archive",
    margin,
    y,
    maxW,
    7
  );
  doc.setFontSize(10);
  y += 4;
  y = writeParagraph(
    doc,
    `Archived at: ${snapshot.archivedAtLabel || snapshot.archivedAt || ""}`,
    margin,
    y,
    maxW,
    lh
  );
  if (snapshot.periodNote) {
    y = writeParagraph(doc, snapshot.periodNote, margin, y + 2, maxW, lh);
  }

  y += 6;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Total Revenue / Total Orders", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(
    doc,
    `Total revenue (paid orders): ${snapshot.totalRevenueFormatted ?? snapshot.totalRevenue ?? "0"}`,
    margin,
    y,
    maxW,
    lh
  );
  y = writeParagraph(
    doc,
    `Total orders: ${snapshot.totalOrders ?? 0}`,
    margin,
    y,
    maxW,
    lh
  );

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Best selling product", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(doc, snapshot.bestSellingLabel || "—", margin, y, maxW, lh);

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Top selling products", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(doc, formatTopSelling(snapshot.topSellingProducts), margin, y, maxW, lh);

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Transactions summary", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  const os = snapshot.orderStats || {};
  y = writeParagraph(
    doc,
    `Successful orders: ${os.successfulOrders ?? 0}\nUnsuccessful orders: ${os.unsuccessfulOrders ?? 0}\nPaid orders: ${os.paidOrders ?? 0}\nToday / week / month revenue: ${os.todayRevenue ?? 0} / ${os.weeklyRevenue ?? 0} / ${os.monthlyRevenue ?? 0}`,
    margin,
    y,
    maxW,
    lh
  );

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Top opened products — Today", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(
    doc,
    formatOpenList(snapshot.openStats?.today),
    margin,
    y,
    maxW,
    lh
  );

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Top opened products — Weekly", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(
    doc,
    formatOpenList(snapshot.openStats?.weekly),
    margin,
    y,
    maxW,
    lh
  );

  y += 4;
  doc.setFontSize(11);
  y = writeParagraph(doc, "Top opened products — Monthly", margin, y, maxW, lh + 0.5);
  doc.setFontSize(10);
  y = writeParagraph(
    doc,
    formatOpenList(snapshot.openStats?.monthly),
    margin,
    y,
    maxW,
    lh
  );

  doc.save(fileName || "dashboard-archive.pdf");
}
